import { generateUniqueRequestId } from './utils';
import isObject from 'lodash-es/isObject';

// 初始化全局请求时间存储对象
const requestTimeMap = new Map();

export default function requestTrackCurry() {
  const requestId = generateUniqueRequestId(); // 自动生成唯一请求ID
  const startTime = Date.now();

  // 记录开始时间
  requestTimeMap.set(requestId, startTime);

  return (eventDesc, requestModule, request = {}, response = {}) => {
    const endTime = Date.now();
    const storedStartTime = requestTimeMap.get(requestId);

    if (!storedStartTime) return; // 如果没有找到开始时间，直接返回

    const duration = endTime - storedStartTime;

    // 清除存储的开始时间
    requestTimeMap.delete(requestId);

    const request_url = isObject(requestModule) ? `${requestModule.module}/${requestModule.address}` : requestModule;
    this.track('request', eventDesc, {
      duration: duration,
      request_url,
      request: request,
      response: response,
    });
  };
}
